import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import axios from './../../axios';
import { isArray } from 'lodash';
import { z } from 'zod';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const assessmentCreateSchema = z.object({
    student_id: z.string(),
    subject_id: z.string(),
});

const GenerateAssessment = ({ handleClose, studentInfo, setNewSelfAssment, setSelfAssessmentCreated }) => {
    let data = JSON.parse(localStorage.getItem("breathForStudent"));
    const teacherInformation = useSelector((state) => state.user.currentUser?.subject_information);
    const userId = useSelector((state) => state.user?.currentUser?.id);
    const [bookChapter, setBookChaptor] = useState({});
    const [books, setBooks] = useState([]);
    const [difficultyLevel, setDifficultyLevel] = useState([]);
    const [skill, setSkill] = useState([]);
    const [domain, setDomain] = useState([]);


    const [assessmentCreateData, setAssessmentCreateData] = useState({
        name: null,
        student_id: userId,
        subject_id: null,
        type_id: "",
        status: "pending",
        standard_id: studentInfo.standard.id,
        section_id: studentInfo.section.id,
        book: null,
        chapter: null,
        knowledgeSkill: null,
        difficultyLevel: null,

    });

    const [selectSubject, setSelectedSubject] = useState(null);
    const [subjectsData, setSubjectsData] = useState([]);
    const getSubjects = () => {
        if (teacherInformation) {
            setSubjectsData([...teacherInformation]);
        }
    };

    useEffect(() => {
        const getQuestionTypes = async () => {
            try {
                let response = await axios.get(`/questionType/get/school/${data.school.id}`);
                if (response) {
                    const mcqId = response.data.data.filter((type) => type.is_manually_graded === false)
                    setAssessmentCreateData((prev) => {
                        return { ...prev, type_id: mcqId[0].id }
                    })
                }
            } catch (error) {

            }
        }
        getQuestionTypes()
    }, [data.school.id])

    const handleGenerateSelfAssessment = async () => {

        try {
            if (!assessmentCreateData.name) {
                toast.error('Please fille Self Assessement name');
                return false;
            }

            if (!assessmentCreateData.subject_id) {
                toast.error('Please select subject');
                return false;
            }
            let response = await axios.post(`/selfAssess/create`, assessmentCreateData);
            handleClose();
            setSelfAssessmentCreated(true)
        } catch (err) {
            let message = err?.response?.data?.message
            toast.error(message ?? "Something went wrong");
        }
    }

    const getDomain = async () => {
        try {
            let response = await axios.get(`/school/domain/get`);
            setDomain(response?.data?.data);
        } catch (err) {
            console.log("error", err)
        }
    }

    const getSkill = async () => {
        try {
            let response = await axios.get(`/school/skill/get`);
            setSkill(response?.data?.data)
        } catch (err) {
            console.log("error", err)
        }
    }

    const getDifficultyLevel = async () => {
        try {
            let response = await axios.get(`/difficultyLevel/get`);
            setDifficultyLevel(response?.data?.data);
        } catch (err) {
            console.log("error", err)
        }
    }

    const getBookAandChapter = async () => {
        try {
            let response = await axios.get(`/cm/library/book/getBookByClassSectionSubject?standard_id=${studentInfo.standard.id}&section_id=${studentInfo.section.id}&subject_id=${selectSubject}&timetableSessionId=${data?.timetable_session?.id}`);
            response = response?.data?.data;
            if (isArray(response)) {
                let bookCh = {};
                response[0].bookInfo.map((val) => {
                    bookCh[val.id] = val;
                })
                setBookChaptor(bookCh);
                setBooks(response[0].bookInfo);
            }

        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getDomain();
        getSkill();
        getDifficultyLevel();
    }, [])

    useEffect(() => {
        if (selectSubject) {
            getBookAandChapter();
        }
    }, [selectSubject]);

    useEffect(() => {
        getSubjects();
    }, [teacherInformation]);
    return (
        <div className="ContainerSelfAssesment">
            <div className='d-flex flex-column SubContainerSelfAssesment'>
                <div className='flex items-center justify-between'>
                    <div className='font-semibold text-blue-900 text-xl'>Create Self-Assessment</div>
                    <div>
                        <img src="/StudentImg/BreathSchoolLogo.png" alt="logo" width="25" />
                    </div>
                </div>
                <div className='my-3'>
                    <label>Title: <span style={{ color: "red" }}>*</span> </label> &nbsp;
                    <input type="text" maxLength={100} className=' bg-transparent border-0 border-bottom w-[92%] outline-none' style={{ outline: "none" }} placeholder=' Please Enter Title' onChange={(e) => setAssessmentCreateData((prev) => {
                        return { ...prev, name: e.target.value }
                    })} />
                </div>
                <div className='grid flex-wrap'>
                    <div className='row'>
                        <div className='col-4 mb-3'>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Subject <span className='text-red-600'>*</span></InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={assessmentCreateData.subject_id ?? ""}
                                    label="Select Subject"
                                    onChange={(e) => {
                                        setSelectedSubject(e.target.value); setAssessmentCreateData((prev) => {
                                            return { ...prev, subject_id: e.target.value == "0" ? null : e.target.value }
                                        })
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                zIndex: 99999,
                                            },
                                        },
                                    }}
                                >
                                    {subjectsData.map((subject, index) => <MenuItem className='z-50' key={subject.id} value={subject.id}>{subject.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-4 mb-3'>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Book</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={assessmentCreateData.book ?? ""}
                                    label="Select Book"
                                    onChange={(e) => setAssessmentCreateData((prev) => {
                                        return { ...prev, book: e.target.value == "0" ? null : e.target.value }
                                    })}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                zIndex: 99999,
                                            },
                                        },
                                    }}
                                >
                                    {books.map((book) => <MenuItem key={book.id} value={book.id}>{book.name}</MenuItem>)}

                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-4 mb-3'>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Chapter</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Chapter"
                                    value={assessmentCreateData.chapter ?? ""}
                                    onChange={(e) => setAssessmentCreateData((prev) => {
                                        return { ...prev, chapter: e.target.value == "0" ? null : e.target.value }
                                    })}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                zIndex: 99999,
                                            },
                                        },
                                    }}
                                >
                                    {assessmentCreateData?.book ? bookChapter[assessmentCreateData.book]?.chapterData.map((chapter) => <MenuItem key={chapter.id} value={chapter.id}>{chapter.chapterName}</MenuItem>) : null}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-4 mb-3'>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Knowledge Skill</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Knowledge Skill"
                                    value={assessmentCreateData.knowledgeSkill ?? ""}
                                    onChange={(e) => setAssessmentCreateData((prev) => {
                                        return { ...prev, knowledgeSkill: e.target.value == "0" ? null : e.target.value }
                                    })}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                zIndex: 99999,
                                            },
                                        },
                                    }}
                                >
                                    {skill.map((skl) => <MenuItem key={skl.id} value={skl.id}>{skl.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-4 mb-3'>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Difficulty Level</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Difficulty Level"
                                    value={assessmentCreateData.difficultyLevel ?? ""}
                                    onChange={(e) => setAssessmentCreateData((prev) => {
                                        return { ...prev, difficultyLevel: e.target.value == "0" ? null : e.target.value }
                                    })}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                zIndex: 99999,
                                            },
                                        },
                                    }}
                                >
                                    {difficultyLevel.map((diffLevel) => <MenuItem key={diffLevel.id} value={diffLevel.id}>{diffLevel.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </div>
                        {/* <div className='col-4 mb-3'>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Select Assessment Type</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Assessment Type"
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                zIndex: 99999,
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value="666909eb17f66bc584e226a0">MCQ</MenuItem>
                                </Select>
                            </FormControl>
                        </div> */}
                    </div>
                </div>
                <div className='d-flex justify-content-between mt-3'>
                    <p className='text-[15px] text-blue-900'>
                        <span className='text-red-700 text-[16px]'>*</span> indicates mandatory fields
                    </p>
                    <div className='flex gap-3 items-center'>
                        <button className='btn me-2 ' style={{ border: "1px solid orange" }} onClick={handleClose}>Cancel</button>
                        <button className='btn bg-white hover:bg-[#F77F00]' disabled={!selectSubject || !assessmentCreateData.name} style={{ border: "1px solid orange" }} onClick={handleGenerateSelfAssessment}>Generate Self-Assessment</button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default GenerateAssessment